import { render, staticRenderFns } from "./NoteCreate.vue?vue&type=template&id=086be185"
import script from "./NoteCreate.vue?vue&type=script&lang=js"
export * from "./NoteCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ClientSelector: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ClientSelector.vue').default,ClientCaseSelector: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ClientCaseSelector.vue').default,ClientTaskSelect: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ClientTaskSelect.vue').default,ClientPlanSelect: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ClientPlanSelect.vue').default,NoteRedactorInput: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/NoteRedactorInput.vue').default,Toggle: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Toggle.vue').default})
